// parser for GU backend dates, i.e. "2024-12-23 22:17:33 PM"
// TODO: replace this stub with dayjs - https://day.js.org/docs/en/parse/string-format
export function parseDateString (str) {
  if (!str) return null

  const parts = str.split(' ')
  return new Date(parts[0] + 'T' + parts[1])
}
